import { z } from 'zod';

// Form Submission — full DB row
export const ZFormSubmission = z.object({
  id: z.string(),
  form_id: z.string(),
  form_version: z.number(),
  form_data: z.record(z.string(), z.unknown()),
  email: z.string(),
  current_step: z.number().nullable(),
  is_complete: z.boolean(),
  utm_source: z.string().nullable(),
  utm_medium: z.string().nullable(),
  utm_campaign: z.string().nullable(),
  utm_term: z.string().nullable(),
  utm_content: z.string().nullable(),
  submitted_to_hubspot: z.boolean(),
  hubspot_contact_id: z.string().nullable(),
  hubspot_contact_url: z.string().nullable(),
  calendly_event_booked: z.boolean(),
  deleted_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  last_activity_at: z.string(),
});

export type IFormSubmission = z.infer<typeof ZFormSubmission>;

// Form Submission Payload — create/update (used by client)
export interface IFormSubmissionPayload {
  id?: string;
  form_id: string;
  form_version: number;
  form_data: Record<string, unknown>;
  email: string;
  current_step?: number;
  is_complete: boolean;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

// UTM Parameters
export interface IUTMParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}
